import React, { useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Button } from 'ksnm-common-ui/lib/Button';
import { Icon } from 'ksnm-common-ui/lib/Icon';
import { Select } from 'ksnm-common-ui/lib/Select';

import { counterpartiesStore, TABS } from '@stores/dictionaryStores/counterpartiesStore/counterpartiesStore';
import { fetchReferences } from '@stores/dictionaryStores/fetchReferences';
import { organizationsStore } from '@stores/dictionaryStores/organizationsStore';

import styles from './Filter.module.scss';

export const Filter = observer((): JSX.Element => {
  const { organization, setOrganization, tab } = counterpartiesStore;
  const { organizations } = organizationsStore;

  useEffect(() => {
    fetchReferences(['organizations']);
  }, []);

  const onClear = useCallback(() => {
    setOrganization(undefined);
  }, [setOrganization]);

  const onChange = useCallback(
    (v) => {
      setOrganization(v);
    },
    [setOrganization],
  );

  return (
    <div className={styles.designFilters}>
      <div className={styles.items}>
        <Select
          items={organizations}
          placeholder="Организация"
          value={organization}
          onChange={onChange}
          size="small"
          showSearch
          className={styles.select}
          disabled={tab === TABS.COMPANIES_CM}
        />
      </div>

      <Button onClick={onClear} disabled={!organization || tab === TABS.COMPANIES_CM} icon={<Icon name="stop" />}>
        Сбросить фильтры
      </Button>
    </div>
  );
});
